<div class="custom-slider {{ id }}" *ngIf="show && yearsBack > 0">
  
  <span class="custom-label-left">{{minValue | date :  isRange ? "mediumDate" : "MMM y"}}</span>
  <ngx-slider
    [(value)]="value"
    [options]="options"
    (userChange)="changeEnd($event)"
    *ngIf="isRange"
    [highValue]="maxValue.getTime()"
  ></ngx-slider>
<span class="custom-label " *ngIf="isRange">{{maxValue | date : "mediumDate"}}</span>
  <ngx-slider
    [(value)]="value"
    [options]="options"
    (userChange)="changeEnd($event)"
    *ngIf="!isRange"
  ></ngx-slider>
  <div
    (click)="presentPopover($event)"
    class="setting-content"
    id="setting-date"
    title="Configurar rango de fechas"
  >
    <ion-icon
      name="settings-outline"
      [ngStyle]="{ color: colorIcon }"
    ></ion-icon>
  </div>
</div>
<div class="date-content" id="min-date{{ id }}">
  <input
    type="{{ isRange ? 'date' : 'month' }}"
    name="min"
    [max]="rangeDate.end"
    [min]="rangeDate.start"
    [value]="value1"
    (change)="setMinValue($event)"
  />
</div>

<div id="max-date{{ id }}" class="date-content">
  <input
    type="date"
    name="min"
    [max]="rangeDate.end"
    [min]="rangeDate.start"
    [value]="value2"
    (change)="setMaxValue($event)"
  />
</div>

<ion-toast
  color="danger"
  [isOpen]="isToastOpen"
  [message]="message"
  [duration]="5000"
  (didDismiss)="setOpen(false)"
></ion-toast>

<ion-popover
  #popover
  [isOpen]="isOpen"
  (didDismiss)="isOpen = false"
  side="top"
  alignment="center"
  [ngClass]="{ 'popover-active': popoverActive }"
>
  <ng-template>
    <ion-content class="ion-padding" color="primary">
      <div class="mb-2">
        <ion-label> Fecha inicio </ion-label>
        <input
          type="date"
          name="mindate"
          [max]="rangeDate.end"
          [value]="settingDate.start"
          (change)="setRangeDateStart($event)"
          style="width: 100%"
        />
      </div>
      <div class="">
        <ion-label> Fecha fin </ion-label>
        <input
          type="date"
          name="maxdate"
          [min]="rangeDate.start"
          [value]="settingDate.end"
          (change)="setRangeDateEnd($event)"
          style="width: 100%"
        />
      </div>

      <div class="buttons-content mt-2">
        <ion-button expand="block" color="secondary" (click)="changeRange()"
          >Guardar</ion-button
        >
        <ion-button color="light" expand="block" (click)="closePopover()"
          >Cancelar</ion-button
        >
      </div>
    </ion-content>
  </ng-template>
</ion-popover>
